import { PhoneRefreshOutlineIcon } from './PhoneRefreshOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 7B9734DE-AFAE-451B-B4DD-D10361B8148C
 * name phone-refresh-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-refresh-outline.svg
 * tags
 * - Cellphone / Phone 
 */
export const PhoneRedialOutlineIcon = PhoneRefreshOutlineIcon;
export default PhoneRedialOutlineIcon